import { apiClient, type Paginated } from '@/core/api';
import type { OnboardingKind, OnboardingStatus } from './constants';
import type { Onboarding, OnboardingInput, OnboardingItem, OnboardingItemInput } from './types';

export const BASE = '/hrm/onboardings/';
const ITEMS = '/hrm/onboarding-items/';

export interface OnboardingListParams {
  page?: number;
  search?: string;
  employee?: number;
  kind?: OnboardingKind;
  status?: OnboardingStatus;
  /** DRF `OrderingFilter` value, e.g. `status` or `-started_on`. */
  ordering?: string;
}

export async function listOnboardings(
  params: OnboardingListParams = {},
): Promise<Paginated<Onboarding>> {
  const { data } = await apiClient.get<Paginated<Onboarding>>(BASE, { params });
  return data;
}

export async function getOnboarding(id: string | number): Promise<Onboarding> {
  const { data } = await apiClient.get<Onboarding>(`${BASE}${id}/`);
  return data;
}

export async function createOnboarding(input: OnboardingInput): Promise<Onboarding> {
  const { data } = await apiClient.post<Onboarding>(BASE, input);
  return data;
}

export async function updateOnboarding(
  id: string | number,
  input: Partial<OnboardingInput>,
): Promise<Onboarding> {
  const { data } = await apiClient.patch<Onboarding>(`${BASE}${id}/`, input);
  return data;
}

export async function deleteOnboarding(id: string | number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}

// ---- Items ----
export async function createOnboardingItem(input: OnboardingItemInput): Promise<OnboardingItem> {
  const { data } = await apiClient.post<OnboardingItem>(ITEMS, input);
  return data;
}

export async function updateOnboardingItem(
  id: number,
  input: Partial<OnboardingItemInput>,
): Promise<OnboardingItem> {
  const { data } = await apiClient.patch<OnboardingItem>(`${ITEMS}${id}/`, input);
  return data;
}

export async function deleteOnboardingItem(id: number): Promise<void> {
  await apiClient.delete(`${ITEMS}${id}/`);
}
